<template>
  <div id="nav">
    <b-navbar toggleable="sm" variant="white" id="main-navbar">
      <b-navbar-brand href="/">
        <b-img width="65" height="38" src="/assets/brand.png" alt="Logo"></b-img>
      </b-navbar-brand>
      <p id="brand-title" class="d-none d-lg-block">Carrefour City St-Mandé</p>

      <b-navbar-nav class="ml-auto">

        <div class="d-flex mr-3">
          <b-navbar-nav class="mr-0">
            <b-nav-item :class="isSelected('/')" href="/" class="text-primary"> Commandes</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item :class="isSelected('/list/users')" href="/list/users">
              Clients
            </b-nav-item>
          </b-navbar-nav>
        </div>

      </b-navbar-nav>

    </b-navbar>
  </div>
</template>


<script>
export default {
  name: "home-navbar",
  methods: {
    isSelected(url) {
      return url == window.location.pathname ? "selected" : "not-selected"
    }
  }
}
</script>

<style lang="scss">

@import "src/assets/styles/custom_variables";

#nav .container {
  padding-top: 5px;
  padding-bottom: 5px;
  max-width: 100%;
}

.navbar-light .navbar-nav .nav-link {
  font-size: 17px;
  margin: 0px 20px;
  letter-spacing: 0.4px;
}


.navbar-light .navbar-nav .nav-link {
  color: $primary;
}

#main-navbar {
  border-bottom: solid 1px $light;
}

.selected {
  border-radius: 10px;
  background-color: $light;
}

.not-selected {
  background-color: white;
}

#brand-title {
  margin-bottom: 0;
  font-size: 1.5rem;
  font-family: Barlow-Semi;
  color: #197933;
}

.navbar-brand {
  margin-right: 0.2rem;
}
</style>